import React from 'react';

import { Box, Header } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
const Wrapper = Box.withConfig({
  marginTop: '$6',
  marginBottom: '$4',
  borderBottomWidth: 1,
  borderColor: getDesignToken('border-color-default'),
});

export const TableHeader = ({ title, testID }: { title: string; testID?: string }) => {
  return (
    <Wrapper testID={testID}>
      <Header variant="headerThree" marginBottom={1} focusable>
        {title}
      </Header>
    </Wrapper>
  );
};
